import React from 'react';
import { NavLink } from 'react-router-dom';

const Banner = () => {
  return (
    <div className='flex flex-row justify-center bg-banner-gradient h-[150px] rounded-2xl'>
        <div className='flex flex-col justify-center items-center'>
            <p className='text-4xl max-sm:text-2xl text-white mt-2 ml-9 font-semibold tracking-wider'>Welcome to CSM</p>
            <a href="https://4xportal.com" target="_blank" rel="noopener noreferrer">
            <p className='text-md text-white ml-3'>BY 4xportal.com</p></a>
            <NavLink to="/home/LiveChat">
                <button className='p-2 m-4 bg-gray-300 rounded-lg hover:bg-blue-700 hover:text-white'>Live Chat</button>
            </NavLink>
        </div>
    </div>
  )
}

export default Banner;